<template>
  <div class="pa-1">
    <v-form v-model="valid" class="white pa-4" style="border-radius: 15px" ref="formAddItem" lazy-validation>
      <block v-if="loading"></block>

      <v-row class="ml-2 mr-2 mb-3">
        <v-col cols="12" class="tabsNh">
          <v-col cols="12" class="d-flex justify-end" style="min-height: 50px">
            <v-btn v-if="$store.getters['rolesUser/getCustomRole'](43)" small class="btn-save"
              @click.prevent.stop="addProductHandler">
              <v-icon> mdi-content-save </v-icon>
            </v-btn>
          </v-col>
        </v-col>
        <v-col cols="12" md="12" style="display: flex; justify-content: space-between; margin-top: 1rem">
          <h2>Información General</h2>
          <div style="display: none">
            <v-checkbox v-model="form.isglobalbranch" label="Mostrar en todas las sucursales"></v-checkbox>
          </div>
        </v-col>
        <v-col cols="6" md="6"></v-col>

        <!--    <v-col cols="3"></v-col> <v-col cols="3">
                        <v-checkbox v-model="isMediccine" label="Es Medicamento"></v-checkbox>
                      </v-col >-->
        <v-col cols="12" md="12">
          <label style="opacity: 0.8">Nota: los campos con (*) al final son requeridos</label>

          <br />
        </v-col>

        <v-col  cols="12" md="3" sm="8" style="margin-top: 0.8rem;justify-content: center">
          <div style="justify-content: center; display: flex; width: 50%; margin-left: 25%">
            <v-img :src="url" class="preview-avatar" />
          </div>
          <v-file-input style="width: 80%; margin-left: 10%" @change="Preview_image" v-model="image"
            label="Seleccione una imágen" prepend-icon="mdi-camera" placeholder="Seleccione una imágen " :rules="[maxFileSize]">
          </v-file-input>
        </v-col>
        <v-col cols="12" md="3" class="mb-2"  >
          <!--  <v-select outlined dense  :items="types" label="Tipo de Articulo*" v-model="form.itemtype" required attach
                              :rules="[(v) => !!v || 'Seleccione el tipo de articulo']"></v-select> -->

          <v-text-field outlined dense v-model="form.itemname" label="Nombre del Articulo*"
            :rules="[(v) => !!v || 'El nombre del articulo es requerido']" @input="fillItemComercialName"
            required></v-text-field>
          <!-- <v-text-field
            outlined
            dense
            v-model="form.itembarcode"
            label="Código de Barra del Articulo"
            required
          ></v-text-field> -->
          <v-autocomplete outlined dense attach :items="unidades" item-value="Valores" item-text="Valores"
            label="Medida de Unidad*" v-model="form.itemmeasureunit"
            :rules="[(v) => !!v || 'Campo requerido']"></v-autocomplete>
          <v-autocomplete 
            outlined 
            dense 
            attach 
            :items="tipoItemCompraGasto" 
            item-value="Codigo" 
            item-text="Valores"
            label="Producto declarable como:" 
            v-model="form.itemdeclarationtype"
            :rules="[(v) => !!v || 'Campo requerido']"
          ></v-autocomplete>
        </v-col>
          <!-- <v-btn class="btnadd" @click="dialogBarCode = true">Gestión de códigos de barra /<br>códigos alternos</v-btn> -->
        <v-col cols="12" md="3" class="mb-2">
          <!--v-select outlined dense  :items="providers" item-text="ProviderName" item-value="ID_Provider" label="Proveedor*" attach
              v-model="form.idprovider" required
              :rules="[(v) => !!v || 'Seleccione el proveedor del articulo']"></v-select-->
          <v-text-field outlined dense v-model="form.itemprice" label="Precio con IVA*" type="number" prefix="$" required
            :rules="[(v) => !!v || 'El precio del articulo es requerido']"></v-text-field>

          <v-text-field outlined dense v-model="form.suggestedPrice" label="Precio sugerido*" type="number" prefix="$"
            required :rules="[(v) => !!v || 'El precio sugerido del articulo es requerido']"></v-text-field>
        </v-col>

        <br />
        <!-- <v-col cols="12" md="12">
            <h3>Informacion Adicional</h3>

            <br />
          </v-col> -->
        <v-col cols="12" md="3">
          <v-text-field outlined dense v-model="form.itemcomercialname"
            label="Nombre Comercial del Articulo"></v-text-field>
          <v-text-field outlined dense v-model="form.itemdescription" label="Descripción del Articulo"></v-text-field>
        </v-col>
        <v-col cols="12" md="3"> </v-col>

        <v-col cols="12" md="4"> </v-col>
        <!--  <v-col cols="12" md="4">

            <v-text-field outlined dense v-model="form.idbusiness" label="ID del Negocio" :hint="business" persistent-hint
              disabled></v-text-field>
          </v-col> -->
        <!--v-col cols="12" md="4">
                                      <v-select outlined dense  attach :items="aditional_type" label="Dato Adicional" v-model="form.aditionaltype"></v-select>
                                  </v-col-->

        <v-col cols="12" class="mt-2 mb-4">
          <v-card class="pa-4">
            <v-row no-gutters>
              <v-col cols="12">
                <b>
                  <v-checkbox
                    v-model="form.existencias"
                    label="Agregar existencia"
                  />
                </b>
              </v-col>
            </v-row>
            <v-row v-if="form.existencias" no-gutters>
              <v-col cols="12" md="4" class="px-2">
                <v-text-field outlined dense v-model="form.existencias_cantidad" type="number" label="Cantidad inicial"
                :rules="[rules.cantidadExistencias]"
                />
              </v-col>
              <v-col cols="12" md="4" class="px-2">
                <v-text-field outlined dense v-model="form.existencias_costo" type="number" step="0.01" min="0" label="Costo unitario"
                :rules="[rules.costoExistencias]"
                />
              </v-col>
              <v-col cols="12" md="4" class="px-2">
                <v-autocomplete 
                  outlined dense label="Almacen" 
                  v-model="form.existencias_warehouse" 
                  :items="warehouses" 
                  item-text="Warehouse" 
                  attach
                  item-value="ID_Warehouse" 
                  :rules="[rules.warehouseExistencias]"
                  />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-4 p-2">
          <v-card class="pa-4">
            <v-row no-gutters>
              <v-col cols="12 mb-2">
                <b>Segmentaciones</b>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                <v-autocomplete outlined dense label="Familia" v-model="form.family" :items="families" item-text="name" attach
                item-value="id" @change="getCategoriesByFamily"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                <v-autocomplete outlined dense label="Categoría" v-model="form.category" :items="categories"
                  item-text="name" attach item-value="id" :disabled="!form.family" @change="getSubsByCategory"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                <v-autocomplete outlined dense label="Subcategoría" v-model="form.subcategory" :items="subcategories"
                  attach item-text="name" item-value="id" :disabled="!form.category"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                <v-autocomplete 
                  outlined 
                  dense 
                  label="Marca" 
                  v-model="form.items_brand" 
                  :items="brands" 
                  item-text="brand" 
                  attach
                  item-value="id">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" class="mb-4">
          <v-card class="pa-4 pt-4">
            <v-row no-gutters>
              <v-col cols="12" class="mb-2">
                <b>
                  Configuraciones
                </b>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-row flex-wrap align-start justify-start">
                  <v-checkbox v-model="form.no_provider" label="Agregar proveedor despues" class="mr-4 mb-2"/>
                  <v-checkbox v-model="form.ishidrocarburo" label="Producto es hidrocarburo" class="mr-4 mb-2"></v-checkbox>
                  <v-checkbox v-model="form.isexempt" label="Producto exento" class="mr-4 mb-2" @change="handleTaxFlagChange('isexempt')"></v-checkbox>
                  <v-checkbox v-model="form.isnosujeto" label="Producto no sujeto" class="mr-4 mb-2" @change="handleTaxFlagChange('isnosujeto')"></v-checkbox>
                  <v-checkbox v-model="form.isnoafecto" label="Producto no gravado" class="mr-4 mb-2" @change="handleTaxFlagChange('isnoafecto')"></v-checkbox>
                  <v-checkbox v-if="posrestaurant" v-model="form.bloquearpropinas" label="No aplicar propina" class="mr-4 mb-2"></v-checkbox>
                  <v-checkbox v-if="ishosting" class="mr-4 mb-2" v-model="form.turismoporalojamiento" label="Aplicar impuesto de turismo por alojamiento"></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-4">
          <v-card class="pa-4 pt-4">
            <v-row no-gutters>
              <v-col cols="12" class="mb-2">
                <b>
                  Gestiones
                </b>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-row flex-wrap align-start justify-start">
                  <v-btn class="btnadd mr-4 mb-2" @click.prevent.stop="dialog = true">
                  Gestionar segmentación
                  </v-btn>
                  <v-btn class="btnadd mr-4 mb-2" @click.prevent.stop="dialogBrand = true">
                  Gestionar marcas
                  </v-btn>
                  <v-btn  color="primary" class="mr-4 mb-2" dark @click="dialogProviders = true">Gestión de proveedores</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-6">
          <v-card class="pa-6">
            <v-card-title class="subtitle-1 font-weight-bold">
              Asignación de Cuentas Contables
            </v-card-title>
            <v-row
              v-for="item in accounts"
              :key="item.model"
              align="center"
              class="mb-4"
            >
              <v-col cols="12" md="4">
                {{ item.label }}
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  :value="getAccountDetail(form[item.model])"
                  readonly
                  dense
                  outlined
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="1" class="text-md-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="setEditCatalog(item.model)"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Seleccionar cuenta contable</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="4">
          <v-autocomplete
            outlined
            dense
            :items="warehouses"
            item-text="Warehouse"
            item-value="ID_Warehouse"
            label="Almacén*"
            attach
            v-model="form.Warehouse"
            :rules="[(v) => !!v || 'Lugar de almacenamiento del artículo es requerido']"
            required
            @change="fillBatchsAndAccountingGroups()"
          >
          </v-autocomplete>
        </v-col> -->
        
      </v-row>
      <v-row>
        <v-col cols="12" md="4" style="display: none !important">
          <v-text-field outlined dense v-model="form.itemconversionfactor" label="Factor de Conversión"></v-text-field>
        </v-col>
        <v-col cols="12" md="2" style="display: none !important">
          <v-text-field outlined dense v-model="form.itemunitspackaging" type="number"
            label="Unidades Packaging"></v-text-field>
        </v-col>
        <v-col cols="12" md="2" style="display: none !important">
          <v-autocomplete outlined dense :items="unidades" label="Unidad Packaging" item-value="Valores"
            item-text="Valores" attach v-model="typepack"></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <h3 style="text-align: center" :class="showBgcolorNotes" @click.prevent="showNotes = !showNotes">
            Comentarios
          </h3>
          <v-dialog v-model="showNotes" scrollable :width="dialogWidth">
            <v-card class="pa-4">
              <div style="
                  margin-top: 0.3rem;
                  margin-bottom: 0.3rem;
                  display: flex;
                  justify-content: flex-end;
                ">
                <v-btn small class="btndelete" @click.prevent="showNotes = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <quill-editor :content="form.itemnote" @change="onEditorChange($event)" v-show="showNotes"
                :options="quillOptions"></quill-editor>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-form>

    <v-dialog v-model="showCatalogo" width="60%">
      <v-card>
        <AccountingItemForm :win="win"
        v-on:sendSelection="setAccountingSelected"
        :isAllowTransaction="isAllowTransaction"
        :PropSearch="propSearchReset"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" scrollable :max-width="dialogWidth" height="100%">
      <ManageCategory :win="win" v-on:reloadCategories="reloadCategories" />
    </v-dialog>

    <v-dialog v-model="dialogProviders" scrollable :max-width="dialogWidth">
      <v-card>
        <v-card-title>
          <h2>Asignación de proveedores</h2>
        </v-card-title>
        <v-card-text>
          <h4>Seleccione los proveedores asociados a este producto.</h4>
          <GeneralFilter :hideLimitLabel="true" :filterEndpoint="filterPromise" :search="{}" @emptyFilter="clearFilter"
            @filtered="filterHandler">
            <DxDataGrid 
            :scrolling="{useNative: true}"
             :show-borders="true"
              :data-source="isFiltered ? providersFiltered : providers">
              <DxPaging :page-size="5" />
              <DxColumn :width="70" cell-template="select-provider" caption=""></DxColumn>
              <DxColumn :width="columnWidth"  data-field="ProviderName" caption="Proveedor"></DxColumn>
              <DxColumn :width="columnWidth"  data-field="ProviderPhone" caption="Télefono"></DxColumn>
              <DxColumn :width="columnWidth"  data-field="ProviderEmail" caption="Correo"></DxColumn>
              <DxColumn :width="columnWidth" data-field="ProviderAddress" caption="Dirección"></DxColumn>

              <template #select-provider="{ data }">
                <div>
                  <v-checkbox v-model="data.data.Checked" />
                </div>
              </template>
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn right class="btncontinue" @click="dialogProviders = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add barcode -->
    <v-dialog v-model="dialogBarCode" scrollable class="barcode-dialog border-boxGlobal" :width="calculateWidth">

      <v-card>
        <block v-if="loadingBarCode"></block>
        <v-card-title>
          <h2 class="mx-3 width-100">Asignación de código de barra / código alterno</h2>
          <span class="mx-3 width-100 note-size"><b>Nota:</b> Los códigos serán creados al guardar el producto</span>
        </v-card-title>
        <v-card-text>
          <!-- <h4>Seleccione los proveedores asociados a este producto.</h4> -->
          <v-row class="mt-3">
            <v-col cols="12" class="d-flex justify-center mx-3">
              <v-text-field outlined dense v-model="barCodeToAdd" label="Código de barra / código alterno *"
                :rules="[(v) => !!v || 'El código de barra / código alterno es requerido']" required
                @keyup.enter="addBarCode"></v-text-field>
              
            </v-col>
            <v-col cols="12" class="d-flex justify-center mx-3">
              <v-btn class="btnadd ml-5 mx-8" @click="addBarCode"><v-icon class="mr-3">mdi-barcode-scan</v-icon>Agregar código</v-btn>
            </v-col>
          </v-row>
          <GeneralFilter :hideLimitLabel="true" :filterEndpoint="filterPromiseBarCodes" :search="search"
            @emptyFilter="clearFilterBarCode" @filtered="filterHandlerBarCodes">
            <DxDataGrid class="isScrolledByGeneralFilter grid-max-width" :show-borders="true"
              :data-source="isFilteredBarCode ? barCodesToSaveFiltered : barCodesToSave">
              <DxPaging :page-size="5" />
              <DxColumn :width="70" cell-template="edit-barcode"></DxColumn>
              <DxColumn data-field="BarCode" caption="Código de barra / Código alterno"></DxColumn>
              <DxColumn cell-template="check-principal" caption="Principal"></DxColumn>
              <template #check-principal="{ data }">
                <div>
                  <center><v-checkbox v-model="data.data.PrincipalBarCode" @change="changePrincipalBarCode(data.data)"></v-checkbox> </center>
                </div>
              </template>
              <DxColumn :width="70" cell-template="delete-barcode"> </DxColumn>
              <template #edit-barcode="{ data }">
                <div>
                  <a class="mx-1" @click="editShowBarCode(data.data)">
                    <v-icon color="primary">mdi-eye</v-icon>
                  </a>
                </div>
              </template>
              <template #delete-barcode="{ data }">
                <div>
                  <a class="mx-1" @click="deleteBarCode(data.data)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </a>
                </div>
              </template>
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn right class="btncontinue" @click="dialogBarCode = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add barcode -->

    <!-- Edit barcode -->
    <v-dialog v-model="dialogEditBarCode" scrollable class="barcode-edit-dialog .border-boxGlobal" max-width="40%">
      <v-card>
        <v-card-title>
          <h2>Editar de código de barra / código alterno - {{ previousCode }}</h2>
        </v-card-title>
        <v-card-text>
          <!-- <h4>Seleccione los proveedores asociados a este producto.</h4> -->
          <v-row class="mt-3">
            <v-col cols="12" class="d-flex justify-center">
              <v-text-field @keyup.enter="editBarCode" outlined dense v-model="barCodeToEdit"
                label="Código de barra / código alterno*"
                :rules="[(v) => !!v || 'El código de barra / código alterno requerido']" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn class="btnadd ml-5" @click="editBarCode">Editar</v-btn>
            <v-btn right class="btncontinue" @click="dialogEditBarCode = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogBrand" scrollable class="barcode-edit-dialog .border-boxGlobal" max-width="40%">
      <v-card> 
        <v-card-title>Marcas</v-card-title>
        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="8"> 
              <v-text-field dense outlined label="Marca" v-model="newBrand" />
            </v-col>
            <v-col cols="4">
              <v-btn right class="btnadd" @click="addBrand">Agregar marca</v-btn>
            </v-col>
          </v-row>

          <v-row>
            <GeneralFilter :hideLimitLabel="true" :filterEndpoint="$API.itemtypes.getBrands" :search="searchBrand"
            @emptyFilter="getBrands" @filtered="setNewBrands">
              <DxDataGrid class="isScrolledByGeneralFilter grid-max-width" :show-borders="true"
              :data-source="tableBrands">
                <DxColumn data-field="brand" caption="Marca" />
                <DxColumn cell-template="template-buttons" caption="" />
                <template #template-buttons="{ data }">
                  <a href="#" @click="deleteBrand(data.data)">
                    <v-icon>mdi-delete</v-icon>
                  </a> 
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-row>

          <v-col cols="12">
            <v-btn right class="btncontinue" @click="dialogBrand = false">Continuar</v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <alerts v-if="alert.show && !dialog" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert"
      class="alert-dialog"></alerts>
  </div>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import { quillConfig } from "../../../helpers/quillconfig";
import { mapState, mapGetters } from "vuex";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
//import AccountingAssign from "../../acounting/partial/AccountingAssign.vue";
import { multipleCriteriaFilter } from "../../../helpers/object";
import ManageCategory from "@/components/Categories/ManageCategory.vue";
import AccountingItemForm from '../../acounting/partial/AccountingItemForm.vue';

const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export default {
  name: "AddProduct",
  props: ["win"],
  components: {
    DxDataGrid,
    DxColumn,

    DxPaging,
    Block,
    Alerts,
    GeneralFilter,
    //AccountingAssign,
    AccountingItemForm,
    ManageCategory,
  },
  data() {
    return {
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      windowWidth: window.innerWidth,
      typepack: "",
      valid: false,
      dialog: false,
      dialogBrand: false,
      newBrand: "",
      url: null,
      showBgcolorNotes: "tabs",
      quillOptions: quillConfig,
      showNotes: false,
      image: null,
      family: null,
      category: null,
      subcategory: null,
      families: [],
      categories: [],
      subcategories: [],
      categoriesAll: [],
      subcategoriesAll: [],
      brands: [],
      tableBrands: [],
      form: {
        family: null,
        category: null,
        subcategory: null,
        isglobalbranch: true,
        isexempt: false,
        isnosujeto: false,
        isnoafecto: false,
        bloquearpropinas: false,
        itemdeclarationtype: 2,
        no_provider: false,
        existencias: false,
        existencias_cantidad: 0,
        existencias_costo: 0,
        existencias_warehouse: null,
      },
      showFamCat: null,
      showCatSub: null,
      units: [
        "Unidades",
        "Libras",
        "Kilos",
        "Galones",
        "Litros",
        "Mililitros",
        "Metros",
        "Centímetros",
      ],
      aditional_type: ["", "Medicamento", "Vacuna"],
      types: [],
      loading: false,
      requiredRule: [(value) => !!value || "Required."],
      /*       form.family: null,
            form.category: null, */
      /*  form.subcategory: null, */
      providers: [],
      business: null,
      isMediccine: false,
      familyName: null,
      //WAREHOUSES
      search: {
        filter: null,
      },
      searchBrand: {
        filter: null,
      },
      warehouses: {},
      batchs: {},
      categoryName: null,
      subName: null,
      toDelete: undefined,
      accountinggroups: {},
      selectaccountinggroup: {},
      loadaedfromprovider: false,
      dialogProviders: false,
      dialogBarCode: false,
      dialogEditBarCode: false,
      providersFiltered: [],
      isFiltered: false,
      isFilteredBarCode: false,
      tabsCategories: "families",
      barCodesToSave: [],
      barCodesToSaveFiltered: [],
      barCodeToAdd: null,
      barCodeToEdit: null,
      previousCode: null,
      loadingBarCode: false,
      validImageSize: true,
      ishosting: JSON.parse(localStorage.getItem("user")).ishosting || 0,
      posrestaurant: JSON.parse(localStorage.getItem("user"))?.posrestaurant || 0,
      brandToDelete: null,
      rules: {
        cantidadExistencias: v =>
        !this.form.existencias ||
        (v !== null && v !== undefined && v !== '' && Number(v) >= 0) ||
        'Agregue una existencia válida. Ej. 0, 1, 2...',
        costoExistencias: v =>
          !this.form.existencias ||
          (v !== null && v !== undefined && v !== '' && Number(v) >= 0) ||
          'Agregue un costo unitario válido. Es requerido agregar al menos 0',
        warehouseExistencias: v =>
          !this.form.existencias ||
          !!v ||
          'Seleccione un almacén'
      },
      accountList: [],
      isAllowTransaction: true,
      showCatalogo: false,
      editAccount: {},
      historyAccount:[],
      accounts: [
        { label: 'Cuenta de Inventario', model: 'id_inventory_account' },
        { label: 'Cuenta de Costos', model: 'id_sales_account' },
        { label: 'Cuenta de Ventas', model: 'id_taxed_sales_account' },
        { label: 'Cuenta de Ventas a Crédito (CXC)', model: 'id_accounts_receivable_payments_account' },
      ],
      propSearchReset: null,
    };
  },
  created() {
    this.$store.dispatch("getParam", { type: "InventoryItemType" }).then((data) => {
      this.types = data.map((param) => {
        return { text: param.ParameterName, value: param.ParameterName };
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);

    this.$store.dispatch("rolesUser/getAllRoles");

    this.form.idbusiness = JSON.parse(localStorage.getItem("user")).businessid;
    this.business = JSON.parse(localStorage.getItem("user")).business;
    this.form.idbranch = JSON.parse(localStorage.getItem("user")).branch;
    this.form.iduser = JSON.parse(localStorage.getItem("user")).id;

    this.search.business = JSON.parse(localStorage.getItem("user")).businessid;
    this.search.branch = JSON.parse(localStorage.getItem("user")).branch;
    this.getAllProviders();
    this.getWarehouses();
    this.getFamilies();
    this.getCategories();
    this.getSubs();
    this.getBrands();
    this.form.id_inventory_account = null;
    this.form.id_sales_account = null;
    this.form.id_accounts_receivable_payments_account = null;
    this.form.id_taxed_sales_account = null;
    this.form.id_account = null;
    this.getAllAcounts();

    if (this.win.meta?.product) {
      this.form.idprovider = this.win.meta?.product;
      this.loadaedfromprovider = true;
    }
    if (this.win.meta?.warehouse) {
      this.form.Warehouse = this.win.meta?.warehouse;
    }    
  },
  computed: {
    //comercialName() {
    //  return this.form.itemname;
    //},
    ...mapGetters(["getCatalogMH"]),
    unidades() {
      return this.getCatalogMH("UnidadMedida");
    },
    tipoItemCompraGasto() {
      return this.getCatalogMH("TipoItemCompraGasto");
    },
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    calculateWidth() {
      return this.windowWidth < 800 ? '85%' : '45%';
    }
    ,
    columnWidth() {
    
    return this.$vuetify.breakpoint.smAndDown ? '80px' : 'auto !important';
  },
  dialogWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "95%" : "60%";
    },
  },
  watch: {
    'form.itemprice'(value){
      this.form.suggestedPrice = value
    },
    'form.existencias'(val){
      if (!val) {
        this.form.existencias_cantidad = 0;
        this.form.existencias_costo = 0;
        this.form.existencias_warehouse = null;
      }
    }
  },
  methods: {
    setEditCatalog(name){
      if (this.editAccount?.name === name) {
        this.showCatalogo = true;
        return;
      }
      this.propSearchReset = '';
      this.showCatalogo = true;
      this.$nextTick(() => {
        this.propSearchReset = null;
      });
      this.editAccount = {
          name: name, 
          old: this.form[name], 
          new: 0
        }; 
    },
    getAccountDetail(id_account){    
      if (!id_account) 
        return 'Sin asignar';
      const listado = this.accountList;
      const account = listado.filter((item) => item.id_account == id_account);
      if (!account || account.length == 0) 
        return 'Sin asignar';
      return account[0]?.account_code + ' ' + account[0]?.account_description;
    },
    getAllAcounts() {
      try {
        this.$API.branchaccountcatalog
          .getActiveBranchAccountCatalog()
          .then(({ data }) => {
            this.accountList = data;            
          });
      } catch (error) {
        console.log(error);
      }
    },
    setAccountingSelected(account){
      this.editAccount.new = account.id_account;
      this.form[this.editAccount.name] = this.editAccount.new;
      console.log(this.editAccount.name , this.form[this.editAccount.name], this.form);
      this.historyAccount[this.editAccount.name] = this.editAccount;
      this.showCatalogo = false;
    },
    deleteBrand(data) {
      this.dialogBrand = false
      this.brandToDelete = data

      this.showAlert(
        "question",
        "Eliminar",
        "¿Está seguro de eliminar la marca? Los productos registrados con esta marca se verán afectados.",
        "deletebrand"
      );
    },
    /*   filterCategories() {
        // filter categories based on selected form.family
        this.categories = this.form.family ? this.form.family.items_categories : [];
        // resetform.subcategory selection
        this.form.category = null;
        this.subcategory = null;
        // reset subcategories
        this.subcategories = [];
      },
      filterSubcategories() {
        // filter subcategories based on selected form.category
        this.subcategories = this.form.category ? this.form.category.items_subcats : [];
        // resetform.subcategory selection
        this.subcategory = null;
      }, */
    accountChanged( e ) {
      this.form.id_account = e
    },
    changePrincipalBarCode(data) {
      if(data.PrincipalBarCode){
        this.barCodesToSave.forEach((item, index) => {
          if (item.BarCode != data.BarCode) {
            this.barCodesToSave[index].PrincipalBarCode = false;
          }
        })
      }
    },
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    fillItemComercialName() {
      this.form.itemcomercialname = this.form.itemname
    },
    checkDuplicate(NewBarCode) {
      if (this.barCodesToSave.some(({ BarCode }) => NewBarCode === BarCode)) {
        return Promise.resolve({ success: false, message: `El código "${NewBarCode}" acaba de ser agregado, agregue uno distinto.` });
      }

      return new Promise((resolve, reject) => {
        this.$API.inventoryitemsbarcodes
          .checkBarCodeExists({ barcode: NewBarCode })
          .then((response) => {
            console.log(response)
            if (!response.success) {
              resolve({ success: false, message: response.message || `El código "${NewBarCode}" acaba de ser agregado, agregue uno distinto.` });
            } else {
              resolve({ success: true });
            }
          })
          .catch((error) => {
            console.log(error)
            reject(false);
          })
          .finally(() => {
            this.barCodeToAdd = null
          })
      })

    },
    addBarCode() {
      this.loadingBarCode = true;
      console.log("entro")
      this.checkDuplicate(this.barCodeToAdd)
        .then(({ success, message }) => {
          console.log(success, message)
          if (success) {
            const newBarCode = {
              BarCode: this.barCodeToAdd,
              PrincipalBarCode: false
            };
            this.barCodesToSave.push(newBarCode)
          } else {
            this.dialogBarCode = false;
            this.showAlert("warning", "Advertencia", message || 'Ya existe.', 'showBackBarcodes');
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.loadingBarCode = false;
        })
    },
    editShowBarCode(data) {
      this.dialogEditBarCode = true;
      this.previousCode = data.BarCode;
      this.barCodeToEdit = this.previousCode;
    },
    editBarCode() {
      this.loadingBarCode = true;
      this.dialogEditBarCode = false;
      this.checkDuplicate(this.barCodeToEdit)
        .then(({ success, message }) => {

          if(!success) {
            this.dialogBarCode = false;
            this.showAlert("warning", "Advertencia", message || 'Ya existe.', 'showBackBarcodes');
          }

          if (success) {
            this.dialogBarCode = false;
            this.showAlert("success", "Éxito", 'El código se actualizó exitosamente.', "showBackBarcodes");
            this.barCodesToSave.find((item) => {
              if (item.BarCode === this.previousCode) {
                item.BarCode = this.barCodeToEdit;
              }
            });
          } 
          this.barCodeToAdd = null;
        })
        .catch((error) => {
          console.error("Error checking duplicate:", error);
        })
        .finally(() => {
          this.loadingBarCode = false;
        });
    },
    deleteBarCode(data) {
      const index = this.barCodesToSave.indexOf(data);
      if (index > -1) {
        this.barCodesToSave.splice(index, 1);
      }
    },
    clearFilter() {
      this.isFiltered = false;
    },
    clearFilterBarCode() {
      this.isFilteredBarCode = false;
    },
    filterHandler(response) {
      this.isFiltered = true;
      this.providersFiltered = response;
    },
    filterPromise(filterObj) {
      const filterArray = [
        "ProviderName",
        "ProviderPhone",
        "ProviderEmail",
        "ProviderAddress",
      ];
      return new Promise((resolve, reject) => {
        try {
          resolve(multipleCriteriaFilter(filterArray, filterObj, this.providers));
        } catch (error) {
          reject(error);
        }
      });
    },
    filterPromiseBarCodes(filterObj) {
      const filterArray = ["BarCode"];
      return new Promise((resolve, reject) => {
        try {
          resolve(multipleCriteriaFilter(filterArray, filterObj, this.barCodesToSave));
        } catch (error) {
          reject(error);
        }
      });
    },
    closeAlert() {
      this.alert.show = false;
      /* this.$store.dispatch('addWindow', { 'name': 'ProductsList', component: 'ProductsList', unique: false }); */
      //this.$store.dispatch("deleteWindowByUuid", { uuid: this.win.uuid });
      this.toDelete = undefined;
      if (this.alert.options == 'showBackBarcodes') {
        this.dialogBarCode = true;
      }

      if (this.alert.options == "deletebrand") {
        this.brandToDelete = null
      }
    },
    ShowDelete(id, action) {
      this.toDelete = id;
      this.showAlert(
        "question",
        "Eliminar Elemento",
        "¿Está seguro que desea eliminar este Elemento?",
        action
      );
    },

    getFamilies() {
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response;
      });
    },
    getCategories() {
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response;
        this.categoriesAll = response;
      });
    },
    async getCategoriesByFamily() {
      this.form.category = null;
      this.form.subcategory = null;
      this.categories = this.categoriesAll.filter(element => element.id_family === this.form.family );
    },
    async getSubsByCategory() {
      this.form.subcategory = null;
      this.subcategories = this.subcategoriesAll.filter(element => element.id_cat === this.form.category );
    },
    async getBrands() {
      this.brands = await this.$API.itemtypes.getBrands( { id_brand: this.form.items_brand } )
      this.tableBrands = this.brands
    },
    async addBrand() {
      this.loading = true
      this.dialogBrand = false
      this.$API.itemtypes.addBrand({ brand: this.newBrand})
        .then(async () => {
          await this.getBrands()
          this.showAlert("success", "Exito", "Se ha registrado la nueva marca.")          
          this.loading = false
        })
        .catch(() => {
          this.showAlert("warning", "Advertencia", "Ocurrio un problema registrando la nueva marca.")
          this.loading = false
        })
    },
    getSubs() {
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response;
        this.subcategoriesAll = response;
      });
    },

    acceptAlert() {
      this.alert.show = false;
      //this.$store.dispatch("deleteWindowByUuid", { uuid: this.win.uuid }); falta el id
      //this.$store.dispatch('addWindow',{'name':'ProductsList',component:'ProductsList',unique:false});

      if (this.alert.options == "destroyFamily") {
        this.destroyFamily(this.toDelete);
      }
      if (this.alert.options == "destroyCat") {
        this.destroyCat(this.toDelete);
      }

      if (this.alert.options == "destroySub") {
        this.destroySub(this.toDelete);
      }

      if (this.alert.options == "deletebrand") {
        this.loading = true
        this.$API.itemtypes.deleteBrand({ id: this.brandToDelete.id })
          .then(async () => {
            await this.getBrands()
            this.brandToDelete = null
            this.showAlert("success", "Exito", "La marca seleccionada ha sido eliminada.")
            this.loading = false
          })
          .catch(() => {
            this.brandToDelete = null
            this.showAlert("warning", "Advertencia", "Ocurrio un problema eliinado la marca seleccionada, por favor intente de nuevo.")
            this.loading = false
          })
      }
    },
    reloadCategories() {
      console.log("reload categories");
      this.getFamilies();
      this.getCategories();
      this.getSubs();
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    handleTaxFlagChange(flag) {
      if (flag === "isexempt" && this.form.isexempt) {
        this.form.isnosujeto = false;
        this.form.isnoafecto = false;
      } else if (flag === "isnosujeto" && this.form.isnosujeto) {
        this.form.isexempt = false;
        this.form.isnoafecto = false;
      } else if (flag === "isnoafecto" && this.form.isnoafecto) {
        this.form.isexempt = false;
        this.form.isnosujeto = false;
      }
    },
    getAllProviders() {
      this.$API.providers.getProviders(this.search).then((response) => {
        this.providers = response;
        this.providers.forEach((obj) => {
          obj.Checked = false;
        });
      });
    },
    addProductHandler() {
      if (this.checkImageSize()) return;
      
      const valid = this.$refs.formAddItem.validate() 
      if (!valid) {
         this.showAlert(
          "warning",
          "Advertencia",
          "Debe llenar todos los campos requeridos"
        );
        return;
      }
      if (!this.valid) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe llenar todos los campos requeridos"
        );
        return;
      }

      const validProviders = this.providers.some((provider) => provider.Checked);
      const noProvider = isTruthyFlag(
        JSON.parse(localStorage.getItem("user"))?.nomergeprodwithprovs
      );
      if (!validProviders && !noProvider && !this.form.no_provider) {
        this.showAlert(
          "warning",
          "Advertencia",
          "El producto debe estar asociado con al menos un proveedor"
        );
        return;
      }

      if (this.barCodesToSave.length > 0) {
        this.form.barCodes = this.barCodesToSave;
      }

      //this.form.itemcomercialname = this.comercialName;
      this.loading = true;
      if (this.form.itemunitspackaging) {
        this.form.itemunitspackaging = this.form.itemunitspackaging + " " + this.typepack;
      }
      const formdata = new FormData();
      if (this.isMediccine) {
        this.form.itemtype = "Medicamentos";
      } else {
        this.form.itemtype = "Otros";
      }
      formdata.append("file", this.image);
      formdata.append("product", JSON.stringify(this.form));

      var providersForProduct = this.providers.filter(
        (item) => item.Checked === true || item.Checked === 1
      );
      formdata.append("providers", JSON.stringify(providersForProduct));

      this.$API.products
        .addProduct(formdata)
        .then((rs) => {
          //throw new Error(response);
          if (this.loadaedfromprovider) {
            this.$store.commit("vetProviders/setvetProductoprov");
          }
          this.showAlert(
            "success",
            "Exito",
            rs.message ? rs.message : "El producto se agrego de manera exitosa",
            "ProductsList"
          );
          this.image = null;
          this.url = null;
          let valuesf = {
            family: this.form.family,
            category: this.form.category,
            subcategory: this.form.subcategory,
            Warehouse: this.form.Warehouse,
            idbranch: this.form.idbranch,
            idbusiness: this.form.idbusiness,
            iduser: this.form.iduser,
            idprovider: this.form.idprovider,
          };
          this.form = {
            idbranch: valuesf.idbranch,
            idbusiness: valuesf.idbusiness,
            iduser: valuesf.iduser,
            idprovider: valuesf.idprovider,
            family: valuesf.family,
            category: valuesf.category,
            subcategory: valuesf.subcategory,
            Warehouse: valuesf.Warehouse,
            itemdeclarationtype: 2,
            isglobalbranch: true,
            isexempt: false,
            isnosujeto: false,
            isnoafecto: false,
            bloquearpropinas: false,
            barCodes: null
          };

          this.barCodesToSave = []

          this.isMediccine = false;
          if (this.isFiltered) {
            this.providersFiltered = this.providersFiltered.map((item) => {
              item.Checked = false;
              return item;
            });
          } else {
            this.providers = this.providers.map((item) => {
              item.Checked = false;
              return item;
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
          this.showAlert("danger", "Error", "Error al agregar el producto");
        }).finally(()=>{
           this.loading = false;
        });
    },
    onEditorChange(e) {
      this.form.itemnote = e.html;
      if (this.form.itemnote != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (this.form.itemnote == "" || this.form.itemnote == "<p><br></p>") {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }
    },

    getWarehouses() {
      this.$API.warehouse.getWarehouses(this.search).then((response) => {
        this.warehouses = response;
      });
    },

    fillBatchsAndAccountingGroups() {
      let warehouse = this.form.Warehouse;
      this.search.warehouse = warehouse;
      this.$API.warehouse
        .getBatchs(this.search)
        .then((response) => {
          this.batchs = response;
        })
        .catch(() => {
          this.batchs = {};
        });

      this.$API.warehouse
        .getAccountingGroups(this.search)
        .then((response) => {
          this.accountinggroups = response;
        })
        .catch(() => {
          this.accountinggroups = {};
        });
    },

    setValInForm() {
      this.form.idaccountingline = this.selectaccountinggroup.ID_AccountingLine;
      this.form.idaccountingcategory = this.selectaccountinggroup.ID_AccountingCategory;
      this.form.idaccountingsubcategory = this.selectaccountinggroup.ID_AccountingSubCategory;
    },

    filterHandlerFamilies(response) {
      this.families = response;
    },

    filterHandlerCategories(response) {
      this.categories = response;
    },

    filterHandlerSubs(response) {
      this.subcategories = response;
    },
    filterHandlerBarCodes(response) {
      this.isFilteredBarCode = true;
      this.barCodesToSaveFiltered = response;
    },
    setNewBrands(response) {
      this.tableBrands = response
    },
    maxFileSize(event) {
      if (!event) return true;
      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event.size;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert("danger", "Error", "El tamaño de la imagen debe ser menor a 2 Mb");
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.btnsave {
  background-color: #3498DB !important;
  color: white;
}

.btnadd {
  background-color: #3498DB !important;
  color: white;
}

.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}

.p-dropdown-panel {
  width: 50%;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.grid-max-width {
  min-width: 100px !important;
}

.barcode-dialog {
  z-index: 100 !important;
}

.barcode-edit-dialog {
  z-index: 200 !important;
}

.alert-dialog {
  z-index: 300 !important;
}

.note-size{
  font-size: 14px;
}

</style>
